export default __webpack_public_path__ + "static/adams-ee0c1ca7e3b246988bf41c6be9b9addc.jpg";